import classNames from 'classnames';
import { Icon, IconName } from '@components/icon';
import { Body } from '@components/text';
import './InfoButton.scss';

export interface InfoButtonProps {
  /** id to reference the element */
  id?: string;
  /** Content text */
  label: string;
  /** If true, InfoButton is disabled */
  disabled?: boolean;
  /** Callback fired on click */
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /** Icon name for icon type */
  icon: IconName;
  /** Optional classname for the component */
  className?: string;
}

/**
 * InfoButton component
 * @param id - A unique identifier for the element.
 * @param label - Content text.
 * @param disabled - If true, InfoButton is disabled.
 * @param onClick - Callback fired on click.
 * @param icon - Icon name for icon type.
 * @param className - Optional classname for the component.
 */
export const InfoButton: React.FC<InfoButtonProps> = ({
  id,
  label,
  disabled,
  icon,
  onClick,
  className,
  ...rest
}) => {
  return (
    <button
      id={id}
      className={classNames('vds-info-button', className)}
      onClick={onClick}
      type="button"
      disabled={disabled}
      {...rest}>
      <Body
        variant="caption"
        size="small"
        align="center"
        weight="bold"
        className={classNames('vds-info-button__label', { disabled: disabled })}>
        {icon && <Icon name={icon} size="small" className="icon" />}
        {label}
      </Body>
    </button>
  );
};
